import { CartLinesUpdateEvent } from '@shopify/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

async function refreshCart() {
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems) {
    await customElements.whenDefined('cart-items-component');
    if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
  }
  const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return res.json();
}

function setButton(button, text, disabled) {
  if (!button) return;
  button.textContent = text;
  button.disabled = disabled;
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('mm-plan__form')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  const label = button.dataset.label || button.textContent;
  button.dataset.label = label;
  setButton(button, 'Lägger till…', true);

  const formData = new FormData(form);
  if (!formData.get('quantity')) formData.set('quantity', '1');
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      credentials: 'same-origin',
    });
    const data = await res.json();
    if (data && data.status) throw new Error(data.description || data.message || 'Kunde inte lägga till');

    const cart = await refreshCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'mm-plan', sections: data.sections, itemCount: 1, didError: false },
    });
    setButton(button, 'Tillagd ✓', true);
    setTimeout(() => setButton(button, label, false), 1800);
  } catch (error) {
    console.warn('[mm-plan] add to cart failed', error);
    try {
      const cart = await refreshCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'mm-plan', itemCount: 1, didError: true },
      });
    } catch (e) {
      deferred.reject(e);
    }
    setButton(button, 'Försök igen', false);
    setTimeout(() => setButton(button, label, false), 2500);
  }
});
